<!-- 申请的资料是否同意组件 -->
<template>
  <div class="comfirm-info">
      <h2 class="account-info-title">{{translateTradeAccountType(tradeAccountType)}}{{$t('common.applyText')}}</h2>
        <div class="refuse-reason" v-if="this.status==='reject'">
          <img src="../../../../assets/images/notice.png" alt="">
          <b>{{remark }}</b>
        </div>
        <div>
          <p class="font-s-pf">{{$t('applyTradeAccount.confirmText')}}</p>
          <el-radio-group v-model="infoIsSome" @change="changeComfirmInfo">
            <el-radio label="yes">{{$t('common.yes')}}</el-radio>
            <el-radio label="no">{{$t('common.no')}}</el-radio>
          </el-radio-group>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    tradeAccountType: {
      type: String,
      default: ''
    },
    remark: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      infoIsSome: ''
    }
  },
  methods: {
    translateTradeAccountType (tradeAccountType) {
      return tradeAccountType ? this.$t('tradeAccountType.' + tradeAccountType) : ''
    },
    changeComfirmInfo () {
      this.$emit('changeComfirmInfo', { infoIsSome: this.infoIsSome })
    }
  }
}
</script>
<style lang="scss" scoped>
.comfirm-info{
  .account-info-title {
    font-family: Muli-Bold;
    font-size: 18px !important;
    color: #182a54 !important;
    letter-spacing: 0.22px;
    border-bottom: 3px solid #ebebeb;
    padding: 10px 5px 20px;
  }
  .statement {
    color: #fec000;
  }
  .refuse-reason {
    background: rgba(254, 192, 0, 0.2);
    border-radius: 6px;
    padding: 20px;
    line-height: 30px;
    word-break: break-all;

    img {
      vertical-align: middle;
    }

    b {
      font-family: Muli-Bold;
      font-size: 14px;
      color: #192b57;
      letter-spacing: 0;
      line-height: 50px;
      padding-left: 20px;
    }
  }
}
</style>
